import "SLICK/slick.js";
import "MFP/jquery.magnific-popup.js";
import './tabbit';
import './togglize';
import './media-video';
(function ($) {
  $(document).ready(function () {
    // console.log('starter theme...');

    let $mainNavTopParentLinks = $("#primary-menu > .menu-item-has-children");
    let $mainNavParentLinks = $("#primary-menu .menu-item-has-children");
    $mainNavTopParentLinks.each(function setupHoverAction(index, item) {
      let $item = $(item);
      let timer = {};
      $item.on("mouseenter", function showSub(e) {
        if (window.matchMedia("(min-width: 981px)").matches) {
          let $subMenu = $(this).children(".sub-menu");
          $subMenu.css({
            opacity: 1,
            visibility: "visible"
          });
          $subMenu.find(".sub-menu.open").addClass("show");
          clearTimeout(timer);
        }
      });
      $item.on("mouseleave", function maybeHideSubmenu(e) {
        if (window.matchMedia("(min-width: 981px)").matches) {
          timer = setTimeout(() => {
            let $subMenu = $(this).children(".sub-menu").first();
            $subMenu.find(".sub-menu.open").removeClass("show");
            $subMenu.css({
              opacity: 0,
              visibility: "hidden"
            });
          }, 300);
        }
      });
    });

    $mainNavTopParentLinks.on("keyup", function (e) {
      if (window.matchMedia("(min-width: 981px)").matches) {
        let spaceBar = 32;
        let enter = 13;
        if (e.keyCode == spaceBar || e.keyCode == enter) {
          let $button = $(this).children("button").first();
          let expanded = $button.attr("aria-expanded") == "true" || false;
          $button.attr("aria-expanded", !expanded);
          let $subMenu = $(this).children(".sub-menu").first();
          $subMenu.stop(true, false, true).slideToggle(300);
        }
      }
    });

    let $nestedSubMenuButtons = $("#primary-menu .sub-menu .menu-item-has-children button");

    $nestedSubMenuButtons.on("keyup", function (e) {
      e.stopPropagation();
    });

    $nestedSubMenuButtons.on("click", function (e) {
      e.stopPropagation();
      if (window.matchMedia("(min-width: 981px)").matches) {
        $(this).parents(".menu-item-has-children").children(".sub-menu").first().toggleClass(["open", "show"]);
      }
    });

    $(".engrain-toggle").on("click", function (e) {
      console.log("click fdsakkfjh");
      $('.engrain-map').css({
        'display': 'block'
      });
    });

    $("#primary-nav-toggle").on("click", function slideMenu(e) {
      let $this = $(this);
      let expanded = $this.attr("aria-expanded") == "true" || false;
      $this.attr("aria-expanded", !expanded);
      $this.next(".menu-primary-menu-container").toggleClass("open");
    });

    const $siteNav = $("#site-navigation");

    let closeMenu = function ($toggleButton, focusButton = false) {
      $toggleButton.attr("aria-expanded", false);
      $toggleButton.next(".menu-primary-menu-container").toggleClass("open");
      if (focusButton) {
        $toggleButton.focus();
      }
      return this;
    };

    $siteNav.on("keyup", function (e) {
      const ESC = 27;
      let $toggleButton = $(this).find("#primary-nav-toggle");
      let expanded = $toggleButton.attr("aria-expanded") == "true";
      if (!expanded) {
        return;
      }

      if (e.keyCode == ESC) {
        closeMenu($toggleButton, true);
      }
    });

    $siteNav.find("#primary-menu").on("focusout", function (e) {
      let $navButton = $siteNav.find("#primary-nav-toggle");
      if ($navButton.attr("aria-expanded") == "false") {
        return;
      }
      if ($(e.relatedTarget).parent().hasClass("menu-item") == false) {
        closeMenu($navButton, false);
      }
    });

    function toggleVideo($button, $video) {
      let label = $button.attr("aria-label");
      if (label === "play") {
        $button.attr("aria-label", "pause");
        $button.removeClass("is-paused").addClass("is-playing");
        $video.trigger("play");
      } else {
        $button.attr("aria-label", "play");
        $button.removeClass("is-playing").addClass("is-paused");
        $video.trigger("pause");
      }
    }

    $(".video-control-button").on("click", function (e) {
      let $this = $(this);
      let $video = $this.parent().siblings("video");
      toggleVideo($this, $video);
    });

    $(".video-control-button").on("keyup", function (e) {
      let spaceBar = 32;
      let enter = 13;
      if (e.keyCode === spaceBar || e.keyCode === enter) {
        e.preventDefault(); // Prevent scrolling on spacebar
        let $this = $(this);
        let $video = $this.parent().siblings("video");
        toggleVideo($this, $video);
      }
    });

    function reduceAllMotion() {
      console.log("reducing motion...");
      $("video").prop("autoplay", false).siblings(".video-control-button-container").find(".video-control-button").attr("aria-label", "play").removeClass("is-playing").addClass("is-paused");
    }

    $(".grid-gallery").each(function (e) {
      $(this)
        .find("a.has-gallery")
        .magnificPopup({
          type: "image",
          image: {
            markup:
              '<div class="mfp-figure">' +
              '<div class="mfp-close"></div>' +
              '<div class="mfp-img"></div>' +
              '<div class="mfp-bottom-bar">' +
              '<div class="mfp-title"></div>' +
              '<div class="mfp-counter"></div>' +
              "</div>" +
              "</div>",
            titleSrc: function (item) {
              return item.img.attr("alt");
            },
            verticalFit: true
          },
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: '<span class="mfp-counter">%curr% of %total%</span>'
          }
        });
    });

    $(".chnl-lightbox-image").magnificPopup({
      type: "image",
      image: {
        markup:
          '<div class="mfp-figure">' +
          '<div class="mfp-close"></div>' +
          '<div class="mfp-img"></div>' +
          '<div class="mfp-bottom-bar">' +
          '<div class="mfp-title"></div>' +
          '<div class="mfp-counter"></div>' +
          "</div>" +
          "</div>",
        titleSrc: function (item) {
          return "<small>Room dimensions and square footage may vary from those shown on this plan. Floorplans are for illustrative purposes only. Please contact your leasing representative for detailed information on your selected plan.</small>";
        },
        verticalFit: true
      }
    });

    $(".open-popup-link").magnificPopup({
      type: "inline",
      midClick: true
    });

		const fpTourDialog = document.getElementById("fp-tour-dialog");
		if (fpTourDialog) {
			const fpTourDialogClose = document.getElementById("close-fp-tour-dialog");
			fpTourDialogClose.addEventListener("click", function(e) {
				fpTourDialog.close();
			});
			const iframeParser = new DOMParser();
			$("#fp-cards").on('click', '.fp-tour-dialog-link', function(e) {
				e.preventDefault();
				let tourContentWrapper = fpTourDialog.querySelector('.tour-content');
				tourContentWrapper.innerHTML = '';
				let newTourContentContainer = e.target.getAttribute('href');
				let newTourContentString = document.querySelector(newTourContentContainer).innerHTML.trim();
				let decodedTour = iframeParser.parseFromString(newTourContentString, 'text/html').body.textContent;
				tourContentWrapper.innerHTML = decodedTour;
				fpTourDialog.showModal();
			});
		}

    $(".fp-gallery-button").on("click", function (e) {
      e.preventDefault();
      let targetGallerySelector = $(this).data("mfp-src");
      let $items = [];
      $(targetGallerySelector)
        .children(".fp-photo")
        .each(function () {
          $items.push({ src: $(this).children("img").attr("src") });
        });
      $.magnificPopup.open({
        items: $items,
        type: "image",
        gallery: {
          enabled: true
        }
      });
    });

    $(".carousel").slick({
      lazyLoad: "ondemand",
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 6000,
      rows: 0,
      infinite: true,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: "ondemand",
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });

    $(".simple-slider").slick({
      lazyLoad: "ondemand",
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      infinite: true,
      prevArrow: "<button class='slick-prev slick-arrow' type='button' style=''><span class='custom-arrow-left'>⟵</span><span aria-hidden='true'></span><span class='slick-sr-only'>Prev</span></button>",
      nextArrow: "<button class='slick-next slick-arrow' type='button' style=''><span class='custom-arrow-right'>⟶</span><span aria-hidden='true'></span><span class='slick-sr-only'>Next</span></button>",
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: "ondemand",
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });

    const tabbed = document.querySelector(".tabbed");
    let tabs = false;
    let panels = false;
    let tablist = false;
    if (tabbed) {
      tablist = tabbed.querySelector("ul.tab-button-list");
      if (tablist) {
        tabs = tablist.querySelectorAll("a");
      }
      panels = tabbed.querySelectorAll(".floor-plan-category");
    }

    const switchTab = (oldTab, newTab) => {
      newTab.focus();
      newTab.removeAttribute("tabindex");
      newTab.setAttribute("aria-selected", "true");
      oldTab.removeAttribute("aria-selected");
      oldTab.setAttribute("tabindex", "-1");
      let index = Array.prototype.indexOf.call(tabs, newTab);
      let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
      panels[oldIndex].hidden = true;
      panels[index].hidden = false;
    };

    if (tabbed && tablist && tabs && panels) {
      tablist.setAttribute("role", "tablist");
      Array.prototype.forEach.call(tabs, (tab, i) => {
        tab.setAttribute("role", "tab");
        tab.setAttribute("id", "tab" + (i + 1));
        tab.setAttribute("tabindex", "-1");
        tab.parentNode.setAttribute("role", "presentation");

        tab.addEventListener("click", e => {
          e.preventDefault();
          let currentTab = tablist.querySelector("[aria-selected]");
          if (e.currentTarget !== currentTab) {
            switchTab(currentTab, e.currentTarget);
          }
        });

        tab.addEventListener("keydown", e => {
          let index = Array.prototype.indexOf.call(tabs, e.currentTarget);
          let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? "down" : null;
          if (dir !== null) {
            e.preventDefault();
            dir === "down" ? panels[i].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
          }
        });
      });

      Array.prototype.forEach.call(panels, (panel, i) => {
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("tabindex", "-1");
        let id = panel.getAttribute("id");
        panel.setAttribute("aria-labelledby", tabs[i].id);
        panel.hidden = true;
      });

      tabs[0].removeAttribute("tabindex");
      tabs[0].setAttribute("aria-selected", "true");
      panels[0].hidden = false;
    }

    const fpWidgetTabbed = $("#floor-plans-widget").tabbit({
      tabIdCreation: "href"
    });

    let $faqToggles = $(".toggle-item").togglize({
      action: "accordion",
      animate: true,
      animateSpeed: "0.5s",
      firstOpen: true,
      adaptiveHeight: false
    });

    $(".expandable a ").append("<span class='arrow'></span>");
  });
})(jQuery);